import React, { useState, useEffect } from "react";
import "../pages/css/DashBoard.css";
import Header from "../pages/components/HeaderUser";
import SideBar from "../pages/components/SidebarUser";
import UserVerificationUser from "../pages/components/UserVerificationUser";
import { getDatabase, ref, push, set, get } from "firebase/database";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import joiningPayqr from "../images/joining-qr.jpg";
import binanceQr from "../images/binace-qr.jpg"; // Add this Binance QR image to your project

function AddFunds() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [walletBalance, setWalletBalance] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState("qr"); // default: QR selected
    const [transactionId, setTransactionId] = useState("");
    const [tdrId, setTdrId] = useState("");
    const [amount, setAmount] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const auth = getAuth();
    const db = getDatabase();
    const navigate = useNavigate();

    UserVerificationUser();

    // Fetch wallet balance
    useEffect(() => {
        if (auth.currentUser) {
            const uid = auth.currentUser.uid;
            get(ref(db, `blackstone-users/${uid}/walletBalance`)).then((snapshot) => {
                if (snapshot.exists()) {
                    setWalletBalance(snapshot.val());
                } else {
                    setWalletBalance(0);
                }
            });
        }
    }, [auth]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!auth.currentUser) return;

        const uid = auth.currentUser.uid;
        const rechargeRef = ref(db, `blackstone-users/${uid}/rechargeDetails`);
        const newKey = push(rechargeRef).key;

        try {
            await set(ref(db, `blackstone-users/${uid}/rechargeDetails/${newKey}`), {
                paymentMethod,
                transactionId,
                tdrId,
                amount: parseFloat(amount),
                status: "pending",
                timestamp: new Date().toISOString(),
            });
            setSubmitted(true);
            // Reset form
            setTransactionId("");
            setTdrId("");
            setAmount("");
        } catch (error) {
            console.error("Error submitting recharge:", error);
        }
    };

    return (
        <>
            <div className="d-flex layout-container">
                <SideBar isOpen={isSidebarOpen} />
                <div className="flex-grow-1">
                    <Header onMenuClick={() => setIsSidebarOpen((prev) => !prev)} />
                    <div className="scrollable-section p-4">
                        <div className="p-4 shadow-md bg-white rounded" style={{ maxWidth: "1300px" }}>
                            <h4 className="mb-4">Recharge Wallet</h4>

                            {submitted && (
                                <div className="alert alert-success">
                                    Your funds will be automatically added to your wallet once the admin verifies your payment.
                                </div>
                            )}

                            {/* Payment method selection */}
                            <div className="mb-4">
                                <h6 className="mb-2">Select Payment Method</h6>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="paymentMethod"
                                        id="qrOption"
                                        value="qr"
                                        checked={paymentMethod === "qr"}
                                        onChange={() => setPaymentMethod("qr")}
                                    />
                                    <label className="form-check-label" htmlFor="qrOption">
                                        QR Payment
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="paymentMethod"
                                        id="binanceOption"
                                        value="binance"
                                        checked={paymentMethod === "binance"}
                                        onChange={() => setPaymentMethod("binance")}
                                    />
                                    <label className="form-check-label" htmlFor="binanceOption">
                                        Binance
                                    </label>
                                </div>
                            </div>

                            <div className="row">
                                {/* Left column: QR code */}
                                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center">
                                    <img
                                        src={paymentMethod === "qr" ? joiningPayqr : binanceQr}
                                        alt={`${paymentMethod === "qr" ? "QR Payment" : "Binance"} QR`}
                                        className="img-fluid mb-3"
                                        style={{
                                            maxHeight: "300px",
                                            borderRadius: "15px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                                        }}
                                    />
                                    {paymentMethod === "binance" && (
                                        <div
                                            className="p-2 bg-light rounded border"
                                            style={{
                                                fontSize: "0.9rem",
                                                wordBreak: "break-all",
                                                maxWidth: "100%",
                                            }}
                                        >
                                            <strong>Binance Deposit Address:</strong>  
                                            <br />
                                            0x0b333734d398a92634f51cea3c125a4f4a9229bc
                                        </div>
                                    )}
                                </div>

                                {/* Right column: Form */}
                                <div className="col-md-6">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">
                                                {paymentMethod === "qr"
                                                    ? "Transaction ID"
                                                    : "Transaction Sharing Value"}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={transactionId}
                                                onChange={(e) => setTransactionId(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">
                                                {paymentMethod === "qr" ? "TDR ID" : "Reference / Txn Note"}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={tdrId}
                                                onChange={(e) => setTdrId(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">
                                                {paymentMethod === "qr"
                                                    ? "Amount (INR)"
                                                    : "Amount (USDT Equivalent)"}
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <button type="submit" className="btn btn-success w-100">
                                            Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddFunds;
